import React from 'react';

function Twitter({ size, fill = 'currentColor', stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      {...otherProps}
    >
      <path d="M18.816 8.06358C18.288 8.30358 17.76 8.44758 17.136 8.54358C17.712 8.15958 18.192 7.63158 18.432 6.95958C17.856 7.29558 17.232 7.53558 16.608 7.67958C16.08 7.10358 15.312 6.76758 14.496 6.76758C12.912 6.76758 11.568 8.06358 11.568 9.69558C11.568 9.93558 11.616 10.1276 11.664 10.3676C9.26405 10.2716 7.10405 9.07158 5.66405 7.34358C5.42405 7.67958 5.28005 8.15958 5.28005 8.68758C5.28005 9.69558 5.80805 10.6076 6.57605 11.0876C6.09605 11.0876 5.66405 10.9436 5.28005 10.7036V10.7516C5.28005 12.1436 6.28805 13.3436 7.63205 13.5836C7.39205 13.6316 7.15205 13.6796 6.86405 13.6796C6.67205 13.6796 6.48005 13.6796 6.33605 13.6316C6.72005 14.7836 7.77605 15.6476 9.07205 15.6476C8.06405 16.4156 6.81605 16.8956 5.47205 16.8956C5.23205 16.8956 4.99205 16.8956 4.80005 16.8476C5.95205 17.7596 7.48805 18.2396 9.12005 18.2396C14.448 18.2396 17.376 13.8236 17.376 9.98358V9.59958C17.952 9.16758 18.432 8.68758 18.816 8.06358Z" />
    </svg>
  );
}

export default Twitter;
